import {requestData} from 'services'
import {GIFT_SHOP_CACHE_TTL_MS} from 'consts'
import {reduxSelector, reduxUpdateDispatcher} from 'lib/redux'

let lastFetch = 0
let activeFetchPromise: Promise<CreatorResponse | null> | null = null

export interface CreatorResponse {
  is_always_compress: boolean
  is_always_resend: boolean
  is_storage_subscriber?: boolean
  rating?: number
  ratingCount?: number
  guidelineCount?: number
  is_live?: boolean
}

function getMapReduxCache(): CreatorResponse | null {
  const state = reduxSelector('user')
  if (!state) return null

  const {compressEnabled, resendEnabled} = reduxSelector('yuserActivationState')

  const {guidelineCount} = reduxSelector('giftshopState')

  return {
    is_always_compress: compressEnabled ?? true,
    is_always_resend: resendEnabled ?? true,
    is_storage_subscriber: state.is_storage_subscriber ?? false,
    rating: state.rating,
    ratingCount: state.ratingCount,
    guidelineCount,
    is_live: state.is_live,
  }
}

async function fetchData(): Promise<CreatorResponse | null> {
  try {
    const response = await requestData('giftshop_get_creator')

    if (typeof response !== 'string' && response.status === 200) {
      lastFetch = Date.now()
      const {result} = response.data

      reduxUpdateDispatcher('user', {
        is_storage_subscriber: result.is_storage_subscriber,
        rating: result.creator_rating,
        ratingCount: result.creator_rating_count,
        is_live: result.is_live,
      })
      reduxUpdateDispatcher('yuserActivationState', {
        compressEnabled: result.is_always_compress,
        resendEnabled: result.is_always_resend,
        creatorStatus: result.status,
      })
      reduxUpdateDispatcher('giftshopState', {
        guidelineCount: result.show_upload_guideline_count,
      })
      return result
    }
  } catch (e) {
    console.error(e)
  } finally {
    activeFetchPromise = null
  }

  return getMapReduxCache()
}

function isCacheValid() {
  const userState = reduxSelector('user')
  const yuserActivationState = reduxSelector('yuserActivationState')
  const isCacheExpired = Date.now() - lastFetch > GIFT_SHOP_CACHE_TTL_MS
  const isDataMissing =
    userState?.is_storage_subscriber === undefined ||
    yuserActivationState?.creatorStatus === undefined

  return !isCacheExpired && !isDataMissing
}

export async function handleGiftshopGetCreator(
  forceRequest = false,
): Promise<CreatorResponse | null> {
  if (activeFetchPromise) return activeFetchPromise

  if (forceRequest || !isCacheValid()) {
    activeFetchPromise = fetchData()

    return activeFetchPromise
  }

  return getMapReduxCache()
}
